import request from '@/utils/request'

export function daoList(data) {
  return request({
    url: '/dao/votes',
    method: 'get',
    params: data,
  })
}

export function proposalslist(data) {
  return request({
    url: '/dao/proposals',
    method: 'get',
    params: data,
  })
}
export function mylist(data) {
  return request({
    url: '/dao/votes',
    method: 'get',
    params: data,
  })
}
export function createProposal(data) {
  return request({
    url: '/dao/createProposal',
    method: 'post',
    data,
  })
}
export function setDescription(data) {
  return request({
    url: '/dao/setDescription',
    method: 'post',
    data: data,
  })
}
export function getDescription(data) {
  return request({
    url: '/dao/description',
    method: 'get',
    params: data,
  })
}
export function detail(data) {
  return request({
    url: '/dao/detail',
    method: 'get',
    params: data,
  })
}
